import { Grid, GridItem, Container, Heading } from '@chakra-ui/react';
import StatWithIcon from './StatWithIcon';

export default function StatsWithIcons({
  stats,
  title,
}: {
  stats: {
    image: {
      sourceUrl: string;
      altText: string;
    };
    item: string;
    text: string;
  }[];
  title?: string;
}) {
  return (
    <Container my={{ base: '14', lg: '24' }}>
      {title && (
        <Heading
          as="h2"
          fontSize={{ base: '1.75rem', lg: '2rem' }}
          lineHeight={{ base: '2rem', lg: '2.25rem' }}
          mb="10"
          textAlign="center"
        >
          {title}
        </Heading>
      )}
      <Grid templateColumns={{ lg: 'repeat(3, 1fr)' }} gap={{ base: '16', lg: '8', xl: '20' }}>
        {stats.map((stat, index) => (
          <GridItem key={index}>
            <StatWithIcon stat={stat} />
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
}
